var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-8-my-requests-show-MVC-wrapper-see-lines-to-edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-8--my-requests---show-MVC-wrapper---see-lines",
    transform: "translate(-1043.000000, -332.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MVC-helper-panel",
    transform: "translate(40.000000, 321.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Status",
    transform: "translate(1002.116421, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-edit-outline",
    transform: "translate(0.883579, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9833795,18 L1.99445983,18 L1.99445983,2 L8.97506925,2 L8.97506925,7 L13.9612188,7 L13.9612188,10.1 L15.9556787,8.1 L15.9556787,6 L9.97229917,0 L1.99445983,0 C0.897506925,0 5.32907052e-15,0.9 5.32907052e-15,2 L5.32907052e-15,18 C5.32907052e-15,19.1 0.897506925,20 1.99445983,20 L5.9833795,20 L5.9833795,18 M16.1551247,11 C16.2548476,11 16.4542936,11.1 16.5540166,11.2 L17.8504155,12.5 C18.0498615,12.7 18.0498615,13.1 17.8504155,13.3 L16.8531856,14.3 L14.7590028,12.2 L15.7562327,11.2 C15.8559557,11.1 15.9556787,11 16.1551247,11 M16.1551247,14.9 L10.0720222,21 L7.97783934,21 L7.97783934,18.9 L14.0609418,12.8 L16.1551247,14.9 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.39f89d8a8c1c48beafb449faf7ada14c.svg";
export { ForwardRef as ReactComponent };